<template>
  <div>
    <template v-if="application.uploadedPhotosCount > 0">
      <div class="alert alert-success rounded alert-with-icon mb-1">
        <Icon icon-name="checkmark-circle-2" class="icon-sm text-success mr-2"></Icon>
        <span>{{ $tc('LoanApplicationTimeline.documentPhotosAdded', application.uploadedPhotosCount) }}</span>
      </div>
      <router-link v-if="canAddMoreDocuments"
                   :to="{ name: 'upload', params: {reference: (application.applicationId || application.reference)} }"
                   class="small">
        {{ $t('LoanApplicationTimeline.addMoreDocuments') }}
      </router-link>
    </template>
    <template v-else>
      <div class="alert alert-warning rounded mb-1">
        <div id="upload-instructions" class="pr-3">{{ $t('LoanApplicationTimeline.uploadPhotosOfIdCard') }}</div>
        <router-link :to="{ name: 'upload', params: {reference: (application.applicationId || application.reference)} }"
                     id="button-add-document-photos"
                     class="btn btn-sm btn-primary mt-3 mb-2 px-3">
          {{ $t('LoanApplicationTimeline.addDocumentPhotos') }}
        </router-link>
      </div>
    </template>
  </div>
</template>
<script>

import Icon from '@shared/components/Icon'

export default {
  name: 'UploadDocumentPhotosComponent',
  props: ['application'],
  components: { Icon },
  computed: {
    canAddMoreDocuments() {
      return !this.$configuration.newCoreEnabled
    }
  }
}
</script>
